// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._19itglyw{border:none}\n._kqswh2mm{position:relative}", ""]);
// Exports
module.exports = exports;
